import { render, staticRenderFns } from "./testimonial-swiper.vue?vue&type=template&id=6d536f71&scoped=true"
import script from "./testimonial-swiper.vue?vue&type=script&lang=js"
export * from "./testimonial-swiper.vue?vue&type=script&lang=js"
import style0 from "./testimonial-swiper.vue?vue&type=style&index=0&id=6d536f71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d536f71",
  null
  
)

export default component.exports